module.exports = __webpack_public_path__ + "static/join-us-bg.4593e53b.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/join-us-bg.png
// module id = 1028
// module chunks = 2